import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css'; // ✅ Бутстрап осы жерде дұрыс тұр

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);

reportWebVitals();
